import { render, staticRenderFns } from "./SelfServiceEmbed.vue?vue&type=template&id=40741fd1&"
import script from "./SelfServiceEmbed.vue?vue&type=script&lang=js&"
export * from "./SelfServiceEmbed.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceEmbed.vue?vue&type=style&index=0&id=40741fd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports